import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=dfb66814&"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfb66814')) {
      api.createRecord('dfb66814', component.options)
    } else {
      api.reload('dfb66814', component.options)
    }
    module.hot.accept("./ForgottenPassword.vue?vue&type=template&id=dfb66814&", function () {
      api.rerender('dfb66814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/authentication/forms/ForgottenPassword.vue"
export default component.exports